const PROMO_LANGUAGE_SEGMENT = /\/(en_US|es_MX|fr_CA)\//

/**
 * Inserts (or replaces) the current i18n language segment in promo S3 image URLs.
 *
 * Default API URL:
 *   .../promotions/BigKahunaGetaway/splashScreen_43.jpg
 * Localized:
 *   .../promotions/BigKahunaGetaway/fr_CA/splashScreen_43.jpg
 */
export const localizePromoImageUrl = (
  url: string | undefined | null,
  language: string
): string => {
  if (!url) {
    return ''
  }

  const lang = language || 'en_US'

  if (PROMO_LANGUAGE_SEGMENT.test(url)) {
    return url.replace(PROMO_LANGUAGE_SEGMENT, `/${lang}/`)
  }

  const lastSlash = url.lastIndexOf('/')
  if (lastSlash < 0) {
    return url
  }

  return `${url.slice(0, lastSlash)}/${lang}${url.slice(lastSlash)}`
}
